import { SelectFields } from '@repo/toolkit/types'

import { Center } from '../../models/center/center'
import { FieldsSelector } from '../../utils'

export const centerBasicFields = [
  'id',
  'name',
  'journeyPlace.address',
  'journeyPlace.country.name',
  'diffusedCenterManager.facNumber',
  'diffusedCenterManager.staff.firstName',
  'diffusedCenterManager.staff.lastName',
  'diffusedCenterManager.staff.phoneNumber'
] as const satisfies FieldsSelector<Center>

export type CenterBasicType = SelectFields<Center, typeof centerBasicFields>
